import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Closable
    if (this.element.classList.contains("is-closable")) {
      this.element.addEventListener("click", this.close);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  close(e) {
    if (e.target.type === "a" || e.target.type === "button") return;
    window.history.back();
  }
}
